import React from "react";
import { Section, Button } from "../Components";
import { FAQ } from "../Components/PageSections";
import App from "../Layouts/AppLayout";

export default function SecurePay() {

  const trustItems = [
    {
      head: 'Licensed & Regulated',
      body: 'Our SecurePay service is fully licensed and adheres to industry regulations to ensure your safety.',
    },
    {
      head: 'Secure Transactions',
      body: 'We use advanced encryption and security protocols to keep your data and funds safe.',
    },
    {
      head: 'Experienced Team',
      body: "With years of experience in handling secure transactions, we're trusted by thousands of customers..",
    },
  ];

  const [faqs, setFaqs] = React.useState([]);

  React.useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/help-center-data/securepay');
        const data = await response.json();
        setFaqs(data);
      } catch (e) {}
    };

    fetchFaqs();
  }, []);

  return (
    <App>
      <div className="tw-relative">
        <Section>
          <h1 className="h1-head">
            Secure Your Transactions with <span className="tw-font-extrabold">PayOnDelivery</span> - Trust,
            Transparency, and Safety
          </h1>
          <p>
            POD SecurePay services protect both buyers and sellers,
            ensuring funds are only released when everyone is
            satisfied
          </p>
        </Section>

        <img
          loading="lazy"
          src="/assets/brand/pod-bg-logo-left.png"
          alt="PayOnDelivery"
          className="tw-absolute tw-bottom-0 tw-right-0 tw-z-0 tw-max-w-full"
          style={{width: '225.45px', height: '301.05px'}}
        />
      </div>

      <img loading="lazy" src="/assets/images/pod-buyer.png" alt="POD Buyer" className='tw-w-full' />

      <Section>
        <h2 className="tw-text-black tw-m-auto md:max-w-70 md:tw-leading-10">
          POD SecurePay ensures a Secure and Trusted transaction for
          both buyers and sellers. It safeguards payments until both
          parties meet their commitments, fostering trust,
          transparency, and fairness—empowering smooth, risk-free
          transactions for everyone involved.
        </h2>
      </Section>

      <div className="tw-bg-primary tw-text-white">
        <Section className="tw-grid tw-gap-4 md:tw-grid-cols-2 md:tw-items-center md:tw-gap-16">
          <div>
            <h3 className="tw-text-white">Why use POD SecurePay for Your Transactions?</h3>
            <p>
              SecurePay eliminates the risk of fraud by
              ensuring no money changes hands until terms are met.
              Your funds are held safely in a SecurePay account
              until the transaction is complete. Both parties can
              move forward with peace of mind knowing that funds
              are protected.
            </p>

            <Button
              illustrated
              title={'Get Started with POD'}
              className="tw-mt-8 tw-hidden md:tw-flex"
              href={'create-link'}
            />
          </div>

          <div>
            <img
              loading="lazy"
              src="/assets/images/buyer-flow.png"
              alt="POD Buyer Flow"
              className="tw-max-w-full"
            />

            <Button
              illustrated
              title={'Get Started with POD'}
              className="tw-mt-4 tw-block tw-w-full md:tw-hidden"
              href={'create-link'}
            />
          </div>
        </Section>
      </div>

      <Section>
        <small>Trust & Security</small>
        <h3 className="tw-text-black">Why Trust POD's SecurePay Service?</h3>

        <div className="tw-mt-4 tw-grid tw-gap-4 md:tw-mt-16 md:tw-grid-cols-4 md:tw-items-center md:tw-gap-16 lg:tw-grid-cols-5 lg:tw-items-start">
          <div className="tw-space-y-4 md:tw-col-span-2 md:tw-space-y-8">
            {trustItems.map((item, index) => (
              <div key={index} className="tw-flex tw-items-start tw-gap-4">
                <svg width="25" height="36" viewBox="0 0 25 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0436 7C5.94451 7 1 11.925 1 18C1 24.075 5.94451 29 12.0436 29C18.1426 29 23.0871 24.075 23.0871 18C23.0871 11.925 18.1426 7 12.0436 7ZM16.8304 16.14C16.9186 16.0396 16.9857 15.9227 17.0278 15.7962C17.0699 15.6696 17.0862 15.5359 17.0757 15.403C17.0652 15.2701 17.0281 15.1406 16.9666 15.0221C16.9051 14.9037 16.8204 14.7987 16.7176 14.7133C16.6147 14.628 16.4958 14.564 16.3677 14.5251C16.2397 14.4862 16.1051 14.4732 15.9719 14.4868C15.8388 14.5005 15.7097 14.5405 15.5923 14.6046C15.4749 14.6687 15.3716 14.7555 15.2884 14.86L10.9713 20.019L8.73752 17.793C8.54817 17.6108 8.29457 17.51 8.03134 17.5123C7.7681 17.5146 7.51629 17.6198 7.33015 17.8052C7.14401 17.9906 7.03842 18.2414 7.03614 18.5036C7.03385 18.7658 7.13504 19.0184 7.31792 19.207L10.3298 22.207C10.4285 22.3052 10.5466 22.3818 10.6766 22.4321C10.8066 22.4823 10.9457 22.505 11.0851 22.4986C11.2244 22.4923 11.3608 22.4572 11.4858 22.3954C11.6107 22.3337 11.7213 22.2467 11.8106 22.14L16.8304 16.14Z"
                    fill="#6D60F6"
                  />
                </svg>

                <div key={index}>
                  <h5>{item.head}</h5>
                  <p>{item.body}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="md:tw-col-span-2 lg:tw-col-span-3">
            <img
              loading="lazy"
              src="/assets/images/buyer-secure-view.png"
              alt="POD Buyer Flow"
              className="tw-w-full tw-max-w-full"
            />
          </div>
        </div>
      </Section>

      <FAQ
        head="Frequently Ask questions about SecurePay..."
        questions={faqs}
      />

    </App>
  );
}
